<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Bonafide Certificate </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="3" md="3" cols="12">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col sm="3" md="3" cols="12">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col sm="2" v-if="sel_ay_data ">
                    <v-btn class="mt-6 button" @click="getCertificateRequestData()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row dense v-if="bonafide_requests!=''">
                <v-col sm="12" md="12" cols="12">
                    <!-- {{ bonafide_requests }} -->
                    <v-simple-table dense v-if="bonafide_requests!=''" class="elevation-1" fixed-header>
                        <thead>
                            <tr>
                                <th class="">Sr. No.</th>
                                <th class="">Registration No.</th>
                                <th class="">Name</th>
                                <th class="">Date</th>
                                <th class="">Standard</th>
                                <th class="">Division</th>
                                <th class="">Certificate Fee</th>
                                <th class="text-center" v-if="certificate_fee != 0">Account Section</th>
                                <th class="text-center">Student Section</th>
                            </tr>
                        </thead>
                        <tbody style="overflow-y: scroll;">
                            <!-- <tr v-for="s in learner_info" :key="s.id"> -->
                            <tr v-for="s,index in bonafide_requests" :key="index">
                                <td>{{ index+1 }}</td>
                                <td>{{ s.child_data[0].grno }}</td>
                                <td>{{ s.child_data[0].name }}</td>
                                <td>{{ s.application_date }}</td>
                                <td>{{ s.child_data[0].std }}</td>
                                <td>{{ s.child_data[0].div }}</td>
                                <td>{{ certificate_fee }}</td>
                                <td v-if="certificate_fee != 0">
                                    <center>
                                        <span v-if="s.is_receipt_generated == false">
                                            <v-btn @click="payfee(s.child_data[0].lid,s.child_data[0].ldid,s.id)" small rounded outlined class="button">Pay Fee</v-btn>
                                        </span>
                                        <span v-else>
                                            <v-tooltip top color="warning">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print1(s.receipt_no)"> <v-icon color="warning">mdi-printer</v-icon>{{s.receipt_no}}</v-btn>
                                                </template>
                                                <span> Print Fee Receipt!!! </span>
                                            </v-tooltip>
                                        </span>
                                    </center>
                                </td>
                                <td class="text-center">
    <span v-if="(s.is_receipt_generated == true || certificate_fee == 0) && s.is_certificate_generated == false">
        <v-btn small rounded outlined class="button" @click="generate_certificate(s.json_data,s.id,s.child_data[0].ldid,s.child_data[0])">Generate Certificate</v-btn>
    </span>
    <span v-else-if="s.is_certificate_generated == true">
        <v-tooltip top color="warning">
            <template v-slot:activator="{ on, attrs }">
<v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print_cerificate(s.child_data[0].ldid, s.child_data[0].grno)">
                        <v-icon color="warning">mdi-printer</v-icon>{{s.certificate_no }}
                </v-btn>
            </template>
            <span> Print Certificate!!! </span>
        </v-tooltip>
    </span>
    <span v-else>
        --
    </span>                      
</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="dialog_fee" max-width="1000px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Pay Bonafide Certificate Fee </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col class="pt-2 mt-2" sm="3" md="3" cols="12"> <strong> Certificate Fee : </strong>{{ certificate_fee }} </v-col>
                            <v-col sm="3" md="3" cols="12">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    rounded
                                    required
                                    v-model="payment_mode"
                                    :items="payment_mode_list"
                                    item-text="name"
                                    item-value="id"
                                    label="Payment Mode"
                                    outlined
                                    persistent-hint
                                    hint="Select Payment Mode"
                                />
                            </v-col>
                            <v-col sm="3" md="3" cols="12">
                                <v-autocomplete color="#0F2027" dense rounded required v-model="bank" :items="bank_list" item-text="name" item-value="id" label="Bank" outlined persistent-hint hint="Select Bank" />
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button mt-3" v-if="payment_mode" @click="pay_cert_fee()">Pay Fee</v-btn>
                            <v-btn class="button mt-3" @click="dialog_fee = false">Cancel</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_gen_cert" max-width="1000px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>Generate Bonafide Certificate</strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <strong>Student Personal Information</strong>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-row dense v-if="child_data" justify="center">
                            <v-col cols="12" sm="4" md="4"> <strong>Name</strong> <v-text-field readonly filled v-model="child_data.name" dense> </v-text-field> </v-col>
                            <v-col cols="12" sm="4" md="4"> <strong>Birth Place</strong> <v-text-field v-model="child_data.birth_place" readonly filled dense> </v-text-field> </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <strong>Date Of Birth</strong>
                                <v-text-field v-model="child_data.dob" readonly filled dense> </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Address</strong> <v-text-field v-model="child_data.laddress" filled readonly dense> </v-text-field> </v-col>
                            <v-col cols="12" sm="4" md="4"> <strong>Cast</strong> <v-text-field v-model="child_data.caste" readonly filled dense> </v-text-field> </v-col>
                        </v-row>
                    </v-card>
                    <!-- <v-card class="box" v-if="json_data">
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <strong>Certificate Request Data</strong>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-row dense justify="center">
                            <v-col cols="12" sm="4" md="4"> <strong>Name</strong> 
                                <v-row dense>
                                <v-checkbox v-model="name" @change="putjsondata(json_data.name,type='name')"  dense color="success"></v-checkbox> -->
                                   <!-- <v-text-field v-model="json_data.name" dense> </v-text-field>  -->
                                <!-- </v-row> -->
                            <!-- </v-col> -->
                            <!-- <v-col cols="12" sm="4" md="4"> -->
                                <!-- <strong>Birth Place </strong> -->
                                <!-- <v-row dense>
                                    <v-checkbox v-model="birth_place" @change="putjsondata(json_data.birth_place,type='birth_place')"  dense color="success"></v-checkbox> -->
                                    <!-- <v-text-field v-model="json_data.birth_place" dense clearable> </v-text-field> -->
                                <!-- </v-row> -->
                            <!-- </v-col> -->
                            <!-- <v-col cols="12" sm="4" md="4">
                                <strong>Date Of Birth </strong> -->
                                <!-- <v-row dense>
                                    <v-checkbox v-model="dob" @change="putjsondata(json_data.dob,type='dob')" dense color="success"></v-checkbox> -->
                                    <!-- <v-text-field v-model="json_data.dob" dense clearable> </v-text-field> -->
                                <!-- </v-row> -->
                            <!-- </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <strong>Address </strong>
                                <v-row dense>
                                    <v-checkbox v-model="laddress" dense @change="putjsondata(json_data.laddress,type='laddress')" color="success"></v-checkbox> -->
                                    <!-- <v-text-field v-model="json_data.laddress" dense clearable> </v-text-field> -->
                                <!-- </v-row> -->
                            <!-- </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <strong>Cast </strong> -->
                                <!-- <v-row dense>
                                    <v-checkbox dense v-model="caste"  @change="putjsondata(json_data.caste,type='caste')"  color="success"></v-checkbox> -->
                                    <!-- <v-text-field v-model="json_data.caste" dense clearable> </v-text-field> -->
                                <!-- </v-row> -->
                            <!-- </v-col> -->
                        <!-- </v-row> -->
                    <!-- </v-card> --> 
                    <center>
                        <v-btn class="button mt-3" @click="dialog_gen_cert = false">Cancel</v-btn>
                        <v-btn class="button mt-3" @click="get_cert_final(json_data)">Generate Certificate</v-btn>
                    </center>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar: false,
                fetch_loader: false,
                gen_cert_loader: false,
                show_cert_loader: false,
                search: "",
                dialog: false,
                awspath: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                data_list: [],
                ay_std_div_list: null,
                sel_ay_data: null,
                overlay: false,
                org_basic_data: [],
                status_list: [
                    { name: "All", id: "0" },
                    { name: "Pending", id: "1" },
                    { name: "Completed", id: "2" },
                ],
                status: null,
                learner_info: [],
                bonafide_requests: [],
                lid: null,
                ldid: null,
                rid: null,
                certificate_fee: null,
                bank: null,
                bank_list: [],
                payment_mode: null,
                payment_mode_list: [],
                dialog_fee: false,
                receipt_no: null,
                json_data: null,
                dialog_gen_cert: null,
                menu: false,
                modal: false,
                menu2: false,
                child_data: null,
                selecetd_data:[],
                birth_place:false,
                dob:false,
                caste:false,
                laddress:false,
                name:false
            };
        },

        methods: {
            arrangevalues() {
            var ind = 0
            for (var i = 0; i < this.selecetd_data.length; i++) {
                //alert(this.selecetd_data[i].index)
                this.selecetd_data[i].index = ind
                ind += 1
            }
        },
            putjsondata(json_data,type){
                   // 
                   var index = this.selecetd_data.length
                if(type == "name"){
                    if(this.name == true){
                        this.selecetd_data.push({name:json_data, index:index})
                    }
                    else{
                      while(index--){
                        if(this.selecetd_data[index] && this.selecetd_data[index].hasOwnProperty(type)){
                            this.selecetd_data.splice(index, 1);
                          //  alert("after splice"+index)
                            this.arrangevalues() 
                         }
                      }
                    }
                }
               
                if(type == "birth_place" ){
                    if(this.birth_place == true){
                        this.selecetd_data.push({birth_place:json_data,index:index})
                    }
                    else{
                        while(index--){
                        if(this.selecetd_data[index] && this.selecetd_data[index].hasOwnProperty(type)){
                            this.selecetd_data.splice(index, 1);
                          //  alert("after splice"+index)
                            this.arrangevalues() 
                         }
                      }
                    }
                }
                if(type == "dob"){
                    if(this.dob == true){
                        this.selecetd_data.push({dob:json_data,index:index})
                    }
                    else{
                        while(index--){
                        if(this.selecetd_data[index] && this.selecetd_data[index].hasOwnProperty(type)){
                            this.selecetd_data.splice(index, 1);
                         //   alert("after splice"+index)
                            this.arrangevalues()
                         }
                      }
                    }
                }
                if(type == "laddress"){
                    if(this.laddress == true){
                        this.selecetd_data.push({laddress:json_data,index:index})
                    }
                    else{
                        while(index--){
                        if(this.selecetd_data[index] && this.selecetd_data[index].hasOwnProperty(type)){
                            this.selecetd_data.splice(index, 1);
                          //  alert("after splice"+index)
                            this.arrangevalues()
                         }
                      }
                    }
                }
                if(type == "caste"){
                    if(this.caste == true){
                        this.selecetd_data.push({caste:json_data,index:index}) 
                    }
                    else{
                        while(index--){
                        if(this.selecetd_data[index] && this.selecetd_data[index].hasOwnProperty(type)){
                            this.selecetd_data.splice(index, 1);
                          //  alert("after splice"+index)
                            this.arrangevalues()
                         }
                      }
                    }
                }
            },
            async get_cert_final(json_data) {
                const payload = {
                    id: this.rid,
                    ldid: this.ldid,
                    name: json_data.name,
                };
                if (json_data.birth_place != null) {
                    payload.birth_place = json_data.birth_place;
                }
                if (json_data.dob != null) {
                    payload.dob = json_data.dob;
                }
                if (json_data.laddress != null) {
                    payload.laddress = json_data.laddress;
                }
                if (json_data.caste != null) {
                    payload.caste = json_data.caste;
                }
                try {
                    this.save_loader = true;
                    const res = await axios.post("/Certificate/saveGenerateBonafideData", payload);
                    // console.log("result", res.data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Certificate Generayed Successfully");
                        this.getCertificateRequestData()
                        this.dialog_gen_cert = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.save_loader = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            generate_certificate(json_data, id, ldid, child_data) {
                this.json_data = JSON.parse(json_data);
             //   this.selecetd_data.push({name:this.json_data.name})
                this.rid = id;
                this.ldid = ldid;
                this.child_data = child_data;
                this.dialog_gen_cert = true;
            },
            payfee(lid, ldid, id) {
                this.lid = lid;
                this.ldid = ldid;
                this.rid = id;
                this.dialog_fee = true;
            },
            print1(receipt_no) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(this.sel_ay_data.ay_id));
                let routeData = this.$router.resolve({
                    name: "certificate-fees-payment-receipt",
                });
                window.open(routeData.href, "_blank");
            },
        print_cerificate(ldid, prno) {
            let routeData = this.$router.resolve({
                name: "bonafide-certificate-des",
                query: {
                    ldid: ldid,
                    prno: prno
                }
            });
            window.open(routeData.href, "_blank");
        },
            async pay_cert_fee() {
                const data = {
                    certificate_fees: this.certificate_fee,
                    lid: this.lid,
                    ldid: this.ldid,
                    rid: this.rid,
                    bank: this.bank,
                    payment_mode: this.payment_mode,
                };
                try {
                    this.save_loader = true;
                    const res = await axios.post("/Certificate/saveGenerateCertificateReceipt", data);
                    // console.log("result", res.data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Fee Paid Successfully");
                       this.getCertificateRequestData()
                        this.dialog_fee = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.save_loader = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            async getCertificateRequestData() {
                this.bonafide_requests = []
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    status: this.status,
                };
                try {
                    this.save_loader = true;
                    const res = await axios.post("/Certificate/getCertificateRequestData", data);
                    // console.log("result", res.data);
                    if (res.data.flag == "YES") {
                        this.bonafide_requests = res.data.bonafide_requests;
                        this.payment_mode_list = res.data.mode_list;
                        this.bank_list = res.data.bank_list;
                        this.certificate_fee = res.data.certificate_fees;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.save_loader = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //   this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.onerror(error);
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.onload();
        },
    };
</script>
<style scoped></style>
